enum CtaType {
  Default = 'Default',
  GetAlerts = 'GetAlerts',
  NotifyMe = 'NotifyMe',
  ViewMoreCars = 'ViewMoreCars',
  ViewSimilarVehicles = 'ViewSimilarVehicles'
}

export default CtaType;
